import { render, staticRenderFns } from "./StoreManagelist.vue?vue&type=template&id=27606684&scoped=true&"
import script from "./StoreManagelist.vue?vue&type=script&lang=js&"
export * from "./StoreManagelist.vue?vue&type=script&lang=js&"
import style0 from "./StoreManagelist.vue?vue&type=style&index=0&id=27606684&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27606684",
  null
  
)

export default component.exports